module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "__parts-nav-hash"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "item",
      class: {
        selected: item.selected
      }
    }, [(!item.to.extUrl) ? _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.caption))]) : _vm._e(), (item.to.extUrl) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": item.to.extUrl
      }
    }, [_vm._v(_vm._s(item.caption))]) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5de4110b","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/Hash.vue
// module id = b1f707ee5da2cdded0b8
// module chunks = 89